/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const ContactPlaceholder = ({ className }) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    viewBox="0 0 400 400"
    width="285px"
    height="285px"
  >
    <path fill="#e8e8e8" d="M0 0h400v400H0z" />
    <path
      fill="currentColor"
      d="M266.8 191.8h-28.9c-9.6 9.3-22.7 15.1-37.1 15.1s-27.5-5.7-37.1-15.1h-30.5c-20.7 0-37.3 16.7-37.3 37.3v55.7c0 20.7 16.7 37.3 37.3 37.3h133.6c20.7 0 37.3-16.7 37.3-37.3v-55.7c0-20.6-16.7-37.3-37.3-37.3z"
    />
    <circle fill="currentColor" cx="200" cy="133.3" r="55.5" />
  </svg>
);

export default ContactPlaceholder;
